export function ShowNothing() {
  return (
    <div className="flex flex-1 items-center justify-center text-gray-200 text-2xl m-24 min-w-96 text-center">
      Nothing to show
    </div>
  )
}
